<template>
    <div>
        <TitleBar>
            <template v-slot:title><translate>Costs</translate></template>
            <template v-slot:buttons>
                <!-- <OnboardingIntroLink :onboarding-intro="'onboarding_web_costs'" /> -->

                <GekkoButton 
                    v-if="!$route.path.includes('control-panel')"
                    :text="$gettext('New Cost')" 
                    icon="fa-solid fa-plus"
                    :to="Urls['costs_add_cost']()"
                    class="btn mr-2"
                />

                <GekkoButton 
                    v-if="$route.path.includes('control-panel')"
                    :text="$gettext('New Cost')" 
                    icon="fa-solid fa-plus"
                    @click="addCostFromControlPanel()"
                    class="btn mr-2"
                />

                <b-dropdown right variant="outline-primary">
                    <template #button-content>
                        <font-awesome-icon icon="fa-solid fa-cloud-download" /><span v-translate>Download</span>
                    </template>
                    <b-dropdown-item @click="exportCosts('csv')" v-b-tooltip.hover.right :title="tooltipTextXls">
                        <font-awesome-icon icon="fa-regular fa-file" /><span v-translate>as excel file (.xls)</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="exportCosts('zip')" class="act" v-b-tooltip.hover.right :title="tooltipTextZip">
                        <font-awesome-icon icon="fa-regular fa-file-zipper" /><span v-translate>xls + images (.zip)</span>
                    </b-dropdown-item>
                </b-dropdown>
            </template>
        </TitleBar>
        <div class="content">
            <CostTable v-if="!$route.path.includes('control-panel')" :excludeTableFields="['is_invoiced']" />
            <AccountantCostTable ref="editable_cost_table" v-if="$route.path.includes('control-panel')" />
        </div>
    </div>
</template>
<script>
    import { mapGetters } from "vuex"
    import TitleBar from "@/components/TitleBar";
    import CostTable from "@/components/costs/CostTable";
    import GekkoButton from "@/components/GekkoButton";
    import AccountantCostTable from "@/components/accountants/control_panel/AccountantCostTable";
    // import OnboardingIntroLink from "@/components/ui/OnboardingIntroLink"

    export default {

        name: "Costs",
        components: {
            TitleBar,
            CostTable,
            GekkoButton,
            AccountantCostTable
            // OnboardingIntroLink
        },
        data() {
            return {
                tooltipTextZip: this.$gettext("Download current selection as xls, and include the proof images, as ZIP archive."),
                tooltipTextXls: this.$gettext("Download current selection as xls only."),
            }
        },
        created(){
        },
        computed:{
            ...mapGetters ({
                visitingCompanyId: 'main/getVisitingCompanyId'
            })
        },
        methods: {
            exportCosts(exportFormat) {
                if(this.isDownloadButtonDisabled()){
                  this.$store.commit('setAlert', {
                    title: this.$gettext("Cost Download"),
                    text: this.$gettext("For security reasons, you cannot initiate another download for 2 minutes."),
                    variant:"info",duration:4});
                  return;
                }
                var url;

                if (this.$route.path.includes('control-panel')) {
                    if (exportFormat === 'csv') {
                        url = window.Urls['costs_export_costs'](this.visitingCompanyId);
                    } else {
                        url = window.Urls['costs_export_costs_zip'](this.visitingCompanyId);
                    }
                } else {
                    if (exportFormat === 'csv') {
                        url = window.Urls['costs_export_costs']();
                    } else {
                        url = window.Urls['costs_export_costs_zip']();
                    }
                }

                let filters = this.$store.getters['filterStore/getFilter'];
                if (this.$route.path.includes('control-panel'))
                    filters.control_panel = true;
                filters.owner_company = this.visitingCompanyId;
                delete filters.option;
                var queryString = this.encodeQueryData(filters);

                if (queryString) {
                    url += "?" + queryString;
                }
                if(exportFormat === "zip"){
                    var alert_text = this.$gettext("You will receive an email with your download URL as soon as your export is ready.");
                    this.$store.commit('setAlert', {title: this.$gettext("Cost Download"), text:alert_text, variant:"info",duration:4});
                }
                location.href = url;
                var expiry_date = new Date();
                expiry_date.setSeconds(expiry_date.getSeconds() + 2*60);
                this.$cookies.set("disable_download_csv_button", true, expiry_date);
            },
            isDownloadButtonDisabled(){
                return this.$cookies.get("disable_download_csv_button") === "true";
            },
            encodeQueryData(data) {
                var ret = [];
                for (var d in data)
                    if (data[d]) {
                        ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]));
                    }
                return ret.join("&");
            },
            addCostFromControlPanel() {
                this.$refs.editable_cost_table.addCost()
            }
        }
    }
    ;
</script>
<style scoped>

</style>
